"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubPayoutType;
(function (SubPayoutType) {
    SubPayoutType["ANCHOR"] = "Anchor";
    SubPayoutType["USER"] = "User";
})(SubPayoutType = exports.SubPayoutType || (exports.SubPayoutType = {}));
